'use strict';

const Organisation = {
    init: function () {
        const listItems = document.querySelectorAll('.organisation-item');
        if (listItems.length > 0) {
            listItems.forEach(item => {
                item.addEventListener('click', (e) => {
                    e.target.classList.toggle('open')
                })
            })
        }

    },
};

export default Organisation;